import en from "./translations/en.json";

export const Dic = {
    en: en,
};

// Also do: FormSchema, WrapperSchema, GameSchema, TemplateSchema, EmailFormats in FreakyFawnAPI